// extracted by mini-css-extract-plugin
export default {"loadingContainer":"BaseLoading_loadingContainer_mNOs1","spinAround":"BaseLoading_spinAround_yPW2N"};